export enum StatusColor {
  GREEN,
  BLUE,
  GRAY,
  RED,
  YELLOW,
}
